// Phase 21 · Fake waveform (Framer Motion audio talking indicator)
import React from "react";
import { motion } from "framer-motion";

const BARS = [0.5, 0.9, 0.7, 1, 0.6, 0.85, 0.55];

export default function FakeWaveform({ active = false, color = "#FFFFFF" }) {
    return (
        <div className="flex items-end justify-center gap-[2px] h-4" aria-hidden="true">
            {BARS.map((h, i) => (
                <motion.span
                    key={i}
                    className="w-[3px] rounded-full"
                    style={{ backgroundColor: color, opacity: active ? 1 : 0.3 }}
                    animate={active ? {
                        scaleY: [h * 0.35, h, h * 0.5],
                    } : { scaleY: 0.35 }}
                    transition={{
                        duration: 0.8 + i * 0.08,
                        repeat: active ? Infinity : 0,
                        repeatType: "mirror",
                        ease: "easeInOut",
                    }}
                />
            ))}
        </div>
    );
}
